




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue'
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Rules from '@/shared/rules/rules';

@Component({
  components: {
    ModalComponent,
    LabelSlot,
  },
})
export default class JustificationReviewedModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  rules: Rules = new Rules();

  justification: string = '';

  get options(): ModalOptions {
    return {
      title: 'Justificativa para mudança de status',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 550,
      persistent: true,
    }
  }

  cancel() {
    this.$emit('cancel');
  }

  handleConfirm() {
    this.$emit('ok', this.justification);
  }
}
